export const capitalize = (str: string): string => str.slice(0, 1).toUpperCase() + str.slice(1);
